import Vue from "vue";

export const leadsService = {
  create
};

function create(params) {
  return Vue.axios.post("/v1/public/leads", params);
}
